function strikeThroughSoldOutVariants() {
  const variantOptions = document.querySelectorAll('select[name="id"] option');

  if (variantOptions.length === 0) {
    // Wait and try again
    setTimeout(strikeThroughSoldOutVariants, 300);
    return;
  }

  variantOptions.forEach(option => {
    if (option.disabled && !option.classList.contains('variant-sold-out')) {
      // Avoid repeating "– Sold Out"
      if (!option.textContent.includes("– Sold Out")) {
        option.textContent = option.textContent.trim() + " – Sold Out";
      }
      option.classList.add("variant-sold-out");
    }
  });
}
document.addEventListener("DOMContentLoaded", strikeThroughSoldOutVariants);



